module.exports = __webpack_public_path__ + "static/media/fen.ce591321.png";